import { render, staticRenderFns } from "./provider-name.vue?vue&type=template&id=37e4b344&scoped=true&"
import script from "./provider-name.vue?vue&type=script&lang=js&"
export * from "./provider-name.vue?vue&type=script&lang=js&"
import style0 from "./provider-name.vue?vue&type=style&index=0&id=37e4b344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e4b344",
  null
  
)

export default component.exports